import {
	FieldWorker,
	FieldWorkerPayrollType,
	JobAssignment,
	PagedResultsOfAuditTrail,
} from 'src/shared/api';
import { createAction, props } from '@ngrx/store';
import { PersonnelDetail } from '../personnel-detail.models';
import { TouchableControl } from 'src/shared/models/TouchableControl';

export const personnelSaved = createAction(
	'[Personnel] Personnel Saved',
	props<{ personnel: FieldWorker }>()
);

export const saveRequestedWithInvalidForm = createAction(
	'[Personnel] Save Requested With Invalid Form',
	props<{ controls: TouchableControl[] }>()
);

export const formErrorCleared = createAction('[Personnel] Form Error Cleared');

export const newPersonnelSaved = createAction(
	'[Personnel] New Personnel Saved',
	props<{ personnel: FieldWorker }>()
);

export const errorSavingPersonnel = createAction(
	'[Personnel] Error Saving Personnel',
	props<{ error: any }>()
);
export const saveRequested = createAction(
	'[Personnel] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: PersonnelDetail }>()
);

export const personnelDetailDestroyed = createAction(
	'[Personnel] Personnel Detail Destroyed'
);

export const personnelSelected = createAction(
	'[Personnel] Personnel Selected',
	props<{ personnelId: number }>()
);

export const personnelLoadedFromApi = createAction(
	'[Personnel] Personnel Loaded From Api',
	props<{ personnel: FieldWorker }>()
);

export const assignmentsLoaded = createAction(
	'[Personnel] Personnel Assignments Loaded From Api',
	props<{ assignments: JobAssignment[] }>()
);

export const personnelLoadedFromStore = createAction(
	'[Personnel] Personnel Loaded From Store',
	props<{ personnel: FieldWorker }>()
);

export const errorLoadingPersonnel = createAction(
	'[Personnel] Error Loading Personnel',
	props<{ error: any }>()
);

export const newPersonnelContinued = createAction(
	'[Personnel] New Personnel Continued',
	props<{ personnel: FieldWorker }>()
);

export const newPersonnelStarted = createAction(
	'[Personnel] New Personnel Started'
);

export const payrollTypeUpdated = createAction(
	'[Personnel] Payroll Type Updated',
	props<{ payrollType: FieldWorkerPayrollType }>()
);

export const fieldWorkerTypeUpdated = createAction(
	'[Personnel] FieldWorker Type Updated',
	props<{ fieldWorkerTypeId: number }>()
);

export const historyRequested = createAction(
	'[Personnel] History Requested'
);

export const historyLoaded = createAction(
	'[Personnel] History Loaded',
	props<{ pagedHistoryResults: PagedResultsOfAuditTrail }>()
);

export const terminateFieldWorker = createAction(
	'[Personnel] Terminate and Unlink Field Worker',
	props<{ fieldWorkerId: Number}>()
)
